<template>
  <div>
    <el-dialog
      title="Insert Artist"
      :visible="dialog"
      width="500px"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      @close="setDialog(false)"
    >
      <el-form label-position="top" >       
        <el-form-item
          label="Artist"
          prop="id"        
        >
          <el-select v-model="artist" clearable filterable class="mr10">
            <el-option
              v-for="a in allArtists.data"
              :key="a.id"
              :value="a.id"
              :label="a.name"
            ></el-option>
          </el-select>
        </el-form-item>  
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {

  data() {  
    return {
      artist: null
    }    
  },

  computed: {      
    ...mapState('newReleasesCarousel', [
      'loading',
      'dialog',
      'allArtists'
    ])
  },

  methods: {
    ...mapActions('newReleasesCarousel', [ 'update', 'getArtists']),
    ...mapMutations('newReleasesCarousel', [
      'setDialog'
    ]),

    submit() {
      this.update(this.artist)
      this.artist = null;
    }
  },

  created() {
    this.getArtists()
  }
}
</script>
